import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import useConvertDate from '../../utils/hooks/useConvertDate';
import styles from './FeedbackCard.module.scss';
import { Button, Spinner, Modal, ModalBody, ModalHeader, ModalFooter, Badge } from 'reactstrap';
import { useToggle } from '../../utils/hooks/useToggle';
import useApiPrivate from '../../utils/hooks/useApiPrivate';
import { Toast } from 'primereact/toast';

const FEEDBACK_URL = 'api/v1/feedback';

export default function FeedbackCard({ feedback, deleteBtn, onCallFeedbackList, userId }) {
  const convertDate = useConvertDate({ date: feedback.created_at, withHour: false });
  const apiPrivate = useApiPrivate();
  const toast = useRef(null);


  const [isLoading, setIsLoading] = useState(false);

  const [modal, setModal, toggleModal] = useToggle(false);

  const showSuccess = (message) => {
    toast.current.show({severity:'success', summary: 'Success', detail: message, life: 3000});
  }
  const showError = (message) => {
      toast.current.show({severity:'error', summary: 'Error', detail: message, life: 3000});
  }

  const handleDeleteFeedbackClick = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await apiPrivate.delete(`${FEEDBACK_URL}/${e.target.id}`);
      showSuccess('Your feedback has been successfully deleted')
      setIsLoading(false);
      setModal(false);
      setTimeout(() => {
        onCallFeedbackList();
      }, 3000);
    }
    catch (error) {
      setIsLoading(false);
      showError('Failed')
    }
    finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader>
          Delete Feedback
        </ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to delete the feedback? If you click the delete button, your feedback will be deleted forever.          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            id={feedback.id}
            onClick={(e) => handleDeleteFeedbackClick(e)}
            disabled={isLoading ? true : false}
            color='danger'
          >
            {
              isLoading
                ? (
                  <>
                    <Spinner size="sm">
                      Loading...
                    </Spinner>
                    <span>
                      {' '}Loading
                    </span>
                  </>
                )
                : 'Yes'
            }
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <div className={` text-body bg-white lgtBackground p-4 mb-4`} >
        <div className={`d-flex flex-column flex-sm-row  flex-wrap align-items-sm-center justify-content-between`}>
          {/* <div> */}
          <div className={`d-flex flex-row flex-wrap align-items-center mb-2 justify-content-between justify-content-sm-start`}>
            <div>
              <i className={`me-2 bi bi-${feedback.type == 'POSITIVE' ? `emoji-smile ${styles.happy}` : feedback.type == 'NEUTRAL' ? `emoji-neutral ${styles.acceptable}` : `emoji-frown ${styles.unhappy}`}`}></i>
              <Link
                to={`/vendor/${feedback.user.id}`}
                className={`text-decoration-none fw-semibold me-3`}
              >
                {feedback.user.username}
              </Link>
            </div>
            <div className={`d-inline-block me-2`}>
              {convertDate}
            </div>
            {/* </div> */}
          </div>
          <div className={`d-flex align-items-center justify-content-end justify-content-sm-between`}>
            {//seller | buyer | admin
              feedback.order_id &&
              <div className={`mb-2 ${deleteBtn && 'me-3'}`}>
                <Badge color='info' >
                  {feedback.user.id == feedback.order.user_id ? 'Buyer' : 'Seller'}
                </Badge>
              </div>
            }
            {
              deleteBtn && userId == feedback.user.id &&
              <div className={`mb-2`}>
                <Button
                  onClick={toggleModal}
                  size='sm'
                >
                  <i className='bi bi-trash me-2 text-danger'></i>
                  Delete
                </Button>
              </div>
            }
          </div>
        </div>
        <div>
          <div>
            {feedback.description}
          </div>
        </div>
        {
          feedback.order &&
          <>
            <div className='bottonDivider my-3'></div>
            <div className={`d-flex flex-wrap text-lighter-color flex-column flex-sm-row ${styles.orderBox}`}>
              <div className={`d-inline-block me-3`}>
                <span>
                  Order: #
                </span>
                <Link
                  to={`/product/${feedback.order.product_id}`}
                  className='text-decoration-none'

                >
                  {feedback.order_id}
                </Link>
              </div>
              <div className={`me-4`}>
                {feedback.order.product.title}
              </div>
              <div>
                ${feedback.order.product.price}
              </div>
            </div>
          </>

        }
      </div>
    </>
  )
}
